/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { roundValueToPrecision } from '@/components/Rating/utils';
import { type ReviewStatistics } from '../interface';

type ReviewStatisticsFormatted = {
  productAverageRating: string[];
  productReviewCount: string[];
};

export const formatReviewStatistics = (
  reviews: ReviewStatistics | undefined,
  skuList: string[]
): ReviewStatisticsFormatted => {
  const productAverageRating: string[] = [];
  const productReviewCount: string[] = [];

  if (!reviews) {
    return {
      productAverageRating,
      productReviewCount,
    };
  }

  skuList.forEach((skuNumber) => {
    const reviewStatistic = reviews[skuNumber];
    const averageRating = roundValueToPrecision(
      Number(reviewStatistic?.averageOverallRating ?? 0),
      0.1
    );
    productAverageRating.push(String(averageRating));
    productReviewCount.push(reviewStatistic?.totalReviewCount ?? '');
  });

  return {
    productAverageRating,
    productReviewCount,
  };
};
